// Module
var code = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\"><path d=\"M19 18a1 1 0 010 2H1a1 1 0 010-2h18zm0-18a1 1 0 011 1v14a1 1 0 01-1 1H1a1 1 0 01-1-1V9a1 1 0 011-1h5V5a1 1 0 011-1h5V1a1 1 0 011-1h6zm-5 14h4V2h-4v12zm-6 0h4V6H8v8zm-6 0h4v-4H2v4z\"/></svg>";
// Exports
module.exports = code;